import { authService } from '../../base/services'

const STORAGE_KEY = 'aquo-screenshot-token'
const URL_PARAM = 'st'

// The screenshot / TV pages are opened as `<page>?st=<token>` (token from
// POST /api/v1/screenshot-token). Keep it for this tab and drop it from the URL.
const readScreenshotToken = () => {
  try {
    const url = new URL(window.location.href)
    const fromUrl = url.searchParams.get(URL_PARAM)
    if (fromUrl) {
      sessionStorage.setItem(STORAGE_KEY, fromUrl)
      url.searchParams.delete(URL_PARAM)
      window.history.replaceState(null, '', url.toString())
      return fromUrl
    }
    return sessionStorage.getItem(STORAGE_KEY)
  } catch (e) {
    return null
  }
}

// For pages that pass the token on (e.g. the TV app's aquo.html iframe)
export const getScreenshotToken = readScreenshotToken

// Headers for the screenshot / TV endpoints: the screenshot token when the page
// was opened with one, otherwise the logged-in user's token
export const screenshotHeaders = () => {
  const token = readScreenshotToken()
  if (token) return { 'x-screenshot-token': token }

  const accessToken = authService.getAccessToken()
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {}
}
